import React from 'react';
import { useParams } from 'react-router-dom';
import { posts } from '../data/sampleData';
import PostCard from '../components/PostCard';

const PostCategory = () => {
  const { category } = useParams();

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center">
          {category.charAt(0).toUpperCase() + category.slice(1)} 관련 포스트
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {posts.map(post => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostCategory;